import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {GeneralService} from './general.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import * as _ from 'lodash';

@Injectable()
export class OrderLineService extends GeneralService {

    static STATUS_OPEN                  = 1;
    static STATUS_ACKNOWLEDGED          = 5;
    static STATUS_CONFIRMED             = 10;
    static STATUS_BACKORDERED           = 12;
    static STATUS_CONFIRMED_AND_CHANGED = 15;
    static STATUS_PARTIALLY_SHIPPED     = 20;
    static STATUS_SHIPPED               = 25;
    static STATUS_PARTIALLY_INVOICED    = 30;
    static STATUS_INVOICED              = 35;
    static STATUS_CLOSED                = 40;
    static STATUS_REJECTED              = 100;

    getStatuses() {
        return [
            {value: null,                                          text: 'All'},
            {value: OrderLineService.STATUS_OPEN,                  text: 'Open'},
            {value: OrderLineService.STATUS_ACKNOWLEDGED,          text: 'Acknowledged'},
            {value: OrderLineService.STATUS_CONFIRMED,             text: 'Confirmed'},
            {value: OrderLineService.STATUS_BACKORDERED,           text: 'Backordered'},
            {value: OrderLineService.STATUS_CONFIRMED_AND_CHANGED, text: 'Confirmed & Changed'},
            {value: OrderLineService.STATUS_PARTIALLY_SHIPPED,     text: 'Partially Shipped'},
            {value: OrderLineService.STATUS_SHIPPED,               text: 'Shipped'},
            {value: OrderLineService.STATUS_PARTIALLY_INVOICED,    text: 'Partially Invoiced'},
            {value: OrderLineService.STATUS_INVOICED,              text: 'Invoiced'},
            {value: OrderLineService.STATUS_CLOSED,                text: 'Closed'},
            {value: OrderLineService.STATUS_REJECTED,              text: 'Rejected'}
        ];
    }

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }

    preloadData(showVendors = true): Observable<any> {
        const showVendorsValue = showVendors ? '1' : '0';
        return this.http.get(this.apiUrl + '/order-lines/preload', {params: {showVendors: showVendorsValue}});
    }

    public getItems(page): Observable<any> {
        const current_page = page.pageNumber + 1;
        let params = new HttpParams();
        params = params.append('perPage', page.size);
        params = params.append('page', current_page.toString());
        if (!_.isUndefined(page.sortParams)) {
            for (const key of Object.keys(page.sortParams)) {
                const value = page.sortParams[key];
                params = params.append('sort[]', key + ',' + value );
            }
        }
        if (!_.isUndefined(page.filterParams)) {
            for (const key of Object.keys(page.filterParams)) {
                const value = page.filterParams[key];
                if (value && value !== '') {
                    params = params.append(key, value);
                }
            }
        }
        return this.http.get(this.apiUrl + '/order-lines', { params : params });
    }

    public updateRequest( PO1_IDs ) {
        const url = `${this.apiUrl}/order-lines/update-request`;
          return this.http.post(url, {PO1_IDs: PO1_IDs})
            .catch(this.handleError);
    }

    export(columns, page, fileName): Observable<any> {
        const url = '/order-line/export?col=' + columns;
        return this.getXlsx(url, page, fileName);
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/order-line.service.ts